import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/reminders")({
	component: RemindersLayout,
});

function RemindersLayout() {
	return <Outlet />;
}
